import { GO_LIVE_DATES } from '../content/dates'
import { StaticPageEntry } from '../types'
import { MEDICAL_TEAM_PATH } from './doctors'

export const HOME_PATH = '/'

/**
 * Non-entity organic pages.
 *
 * `dateModified` must be bumped by hand when the page content really changes (PRD §50); it feeds the
 * sitemap `lastmod` and WebPage JSON-LD. Never compute it at build/request time.
 *
 * Home: `dateModified` is the date the organic homepage content of this project was written — bump it to
 * the real release date when it ships. `datePublished` is unknown (the route predates this project) and
 * therefore left undefined.
 */
export const STATIC_PAGES: StaticPageEntry[] = [
  {
    kind: 'page',
    slug: 'home',
    path: HOME_PATH,
    name: 'Medleve',
    published: true,
    requiresReview: false,
    review: { ...GO_LIVE_DATES, references: [], reviewStatus: 'approved' }
  },
  {
    kind: 'page',
    slug: 'equipe-medica',
    path: MEDICAL_TEAM_PATH,
    name: 'Equipe médica',
    // Host-scoped rewrite preserves the original Omens team page.
    published: true,
    requiresReview: false,
    review: { ...GO_LIVE_DATES, references: [], reviewStatus: 'approved' }
  }
]
